var map = {
	"./cai.svg": "w2Ze",
	"./close.svg": "toIl",
	"./config.svg": "e/UX",
	"./del.svg": "CWZL",
	"./down-arrow.svg": "5Hsj",
	"./exit.svg": "QQPv",
	"./input-close.svg": "jXRZ",
	"./list-arrow.svg": "b4xV",
	"./list.svg": "vuHp",
	"./over.svg": "LXop",
	"./right-arrow.svg": "k8r5",
	"./right.svg": "9iyg",
	"./search.svg": "Bx0U",
	"./xiala.svg": "nwQm",
	"./zan.svg": "M++c"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 76